import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Input } from 'react-toolbox';
import cx from 'classnames';
import PhoneInput from 'components/PhoneType/PhoneInput';
import WorkroomSelect from 'components/formElements/WorkroomSelect';
import FlexBox from 'flexbox-react';
import { ThemeProvider } from 'react-css-themr';
import styles from 'styles/form';
import RTInput from 'styles/input';
import RTDropdown from 'styles/dropdown';
import RTCard from 'styles/card';
import PhoneType from 'components/PhoneType';
import { error } from '../../../../utils';
import RTSwitch from 'styles/switch';
import DatePicker from 'components/DatePicker';
import { handleDateSave } from '../../../../utils/dateUtils.js';
import UserType from 'types/user';
import ReactSelect from 'components/StyledSelect/react_select';
import reactSelectStyles from 'components/ReactSelect/styles';
import { TIMEZONES } from 'config/constants';

const theme = { RTInput, RTDropdown, RTCard, RTSwitch };

const mediumInput = cx({
  [styles.inputs]: true,
  [styles.largeInput]: true,
});

const TIMEZONE_SOURCE = TIMEZONES.map(tz => ({ value: tz, label: tz }));

class UserForm extends Component {
  static propTypes = {
    errors: PropTypes.object,
    user: UserType,
    onChange: PropTypes.func,
    children: PropTypes.node,
    leadCertField: PropTypes.bool,
  }

  static defaultProps = { leadCertField: false };

  constructor(props) {
    super(props);
    this.handlePrimaryType = this.handleChange.bind(this, 'primary_phone_type');
    this.handleSecondaryType = this.handleChange.bind(this, 'secondary_phone_type');
    this.handleName = this.handleChange.bind(this, 'name');
    this.handleEmail = this.handleChange.bind(this, 'email');
    this.handleSecondaryPhone = this.handleChange.bind(this, 'secondary_phone');
    this.handleLeadCertNumber = this.handleChange.bind(this, 'lead_cert_number');
    this.handlePrimaryPhone = this.handleChange.bind(this, 'primary_phone');
    this.handleBadgeNumber = this.handleBadgeChange.bind(this, 'number');
    this.handleBadgeExpiration = this.handleBadgeChange.bind(this, 'expiration');
    this.handleSelectChange = (key, value) => this.handleChange(key, value.map(v => v.value));
    this.handleWorkrooms = this.handleSelectChange.bind(this, 'workroom_ids');

    const { user } = this.props;
    this.state = {
      user: (user && { ...props.user }) || {
        active: true,
        primary_phone_type: 'mobile',
        secondary_phone_type: 'mobile',
        badge: {},
      },
    };
  }

  onChange(user) {
    this.setState({ user });
    const { badge, ...userAttributes } = this.state.user;
    const newBadge = badge || {};
    const { expiration, ...otherBadgeThings } = newBadge;
    this.props.onChange({
      ...userAttributes,
      id: user.user_id,
      badge_attributes: {
        ...otherBadgeThings,
        expiration: handleDateSave(expiration),
      },
    });
  }

  handleTimezone = (option) => {
    const user = this.state.user;
    user.timezone = option.value;
    this.onChange(user);
  }

  handleChange(key, value) {
    const { user } = this.state;
    user[key] = key === 'email' ? value.replaceAll(' ', '') : value;
    this.onChange(user);
  }

  handleBadgeChange(key, value) {
    const { user } = this.state;
    user.badge = user.badge || {};
    user.badge[key] = value;
    this.onChange(user);
  }

  render() {
    const { user } = this.state;
    const { errors, children, leadCertField } = this.props;
    const badge = user.badge || {};

    return (
      <ThemeProvider theme={theme}>
        <div>
          <FlexBox flexWrap="wrap" className={styles.divider}>
            <Input
              label="Name"
              className={mediumInput}
              value={user.name}
              onChange={this.handleName}
              error={error('user.name', errors)}
              required
            />
            {children}
          </FlexBox>
          <FlexBox flexWrap="wrap" className={styles.divider}>
            <Input
              label="Email"
              type="email"
              value={user.email}
              className={mediumInput}
              onChange={this.handleEmail}
              error={error('user.email', errors)}
              required
            />
            <PhoneInput
              label="Primary Phone"
              type="tel"
              value={user.primary_phone}
              className={mediumInput}
              onChange={this.handlePrimaryPhone}
              error={error('user.primary_phone', errors)}
              required
            >
              <PhoneType value={user.primary_phone_type} onChange={this.handlePrimaryType} />
            </PhoneInput>
            <PhoneInput
              label="Secondary Phone"
              type="tel"
              value={user.secondary_phone}
              className={mediumInput}
              onChange={this.handleSecondaryPhone}
              error={error('user.secondary_phone', errors)}
            >
              <PhoneType
                value={user.secondary_phone_type}
                onChange={this.handleSecondaryType}
              />
            </PhoneInput>
            <ReactSelect
              className={mediumInput}
              label="Time Zone"
              placeholder={'Select Time Zone'}
              onChange={this.handleTimezone}
              options={TIMEZONE_SOURCE}
              value={user.timezone}
              error={error('timezone', errors)}
              required
            />
            {leadCertField &&
              <Input
                label="Lead Cert Number"
                value={user.lead_cert_number}
                className={mediumInput}
                onChange={this.handleLeadCertNumber}
                error={error('user.lead_cert_number', errors)}
              />
            }
          </FlexBox>
          <FlexBox flexWrap="wrap" className={styles.divider}>
            <Input
              label="Badge number"
              className={mediumInput}
              value={badge.number}
              onChange={this.handleBadgeNumber}
              error={error('user.badge.number', errors)}
            />
            <DatePicker
              label="Badge expiration"
              className={mediumInput}
              value={badge.expiration}
              onChange={this.handleBadgeExpiration}
              error={error('user.badge.expiration', errors)}
            />
          </FlexBox>
          <FlexBox flexWrap="wrap" className={styles.divider}>
            <WorkroomSelect
              value={user.workroom_ids}
              onChange={this.handleWorkrooms}
              placeholder="Select workroom(s)"
              className={reactSelectStyles.selectWrapper}
            />
          </FlexBox>
        </div>
      </ThemeProvider>
    );
  }
}

export default UserForm;



// WEBPACK FOOTER //
// ./client/app/shared/components/users/UserForm/index.jsx